import { useCallback, useState } from 'react'

export const useStepper = (
  initialStep = 1,
  min = 0,
  max = Number.MAX_SAFE_INTEGER
) => {
  const [step, setStep] = useState(initialStep)
  const goToNextStep = useCallback(
    () => setStep((step) => (step < max ? step + 1 : step)),
    [max]
  )
  const goToPrevStep = useCallback(
    () => setStep((step) => (step > min ? step - 1 : step)),
    [min]
  )
  return { step, setStep, goToNextStep, goToPrevStep }
}

export default useStepper
